/**
 * @fileoverview POST handler for the "/apps/:app_id/push_credential" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdPushCredentialCacheKeys } from "./constants";
import type { PostAppsAppIdPushCredentialProps, AppsAppIdPushCredentialResult } from "./types";

export const postAppsAppIdPushCredential = reactQueryMutationAdapter(
  appsAppIdPushCredentialCacheKeys,
  (props: PostAppsAppIdPushCredentialProps): Promise<AppsAppIdPushCredentialResult> => {
    return fetch(
      `/apps/${props.appId}/push_credential`,
      "POST",
      {},
      { body: JSON.stringify(props.data) },
      { propagateFetchRequestError: false }
    );
  }
);
